// extracted by mini-css-extract-plugin
module.exports = {"title":"Headline_title___FJK2","subtitle":"Headline_subtitle__3Zmqc"};